var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.28537 4.67707L9.28568 4.67723L17.8457 8.95723C19.6932 9.88097 20.4493 11.0127 20.4493 12C20.4493 12.9873 19.6932 14.1191 17.8457 15.0428L9.28568 19.3228C7.87587 20.0277 6.71096 20.3928 5.80966 20.4787C4.90622 20.5648 4.3367 20.367 4.00807 20.0379C3.67939 19.7088 3.48235 19.1389 3.56918 18.2358C3.65579 17.335 4.02142 16.1714 4.72618 14.7643C4.72624 14.7641 4.72629 14.764 4.72635 14.7639L5.59598 13.0347L5.59601 13.0347L5.59825 13.0301C5.9163 12.3813 5.9163 11.6288 5.59825 10.9799L5.59826 10.9799L5.5965 10.9764L4.7265 9.23641L4.72635 9.23609C4.02153 7.8289 3.65651 6.66532 3.57062 5.76458C3.48454 4.86176 3.68222 4.29168 4.01159 3.96232C4.34096 3.63295 4.91103 3.43526 5.81386 3.52135C6.71459 3.60723 7.87818 3.97225 9.28537 4.67707ZM9.43929 13.25H14.8393C15.5254 13.25 16.0893 12.6862 16.0893 12C16.0893 11.3139 15.5254 10.75 14.8393 10.75H9.43929C8.75314 10.75 8.18929 11.3139 8.18929 12C8.18929 12.6862 8.75314 13.25 9.43929 13.25Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendWhite);
export default __webpack_public_path__ + "static/media/send-white.807f455986bb862e0109fae8e75cea53.svg";
export { ForwardRef as ReactComponent };